import { render, staticRenderFns } from "./CalendarAside.vue?vue&type=template&id=5356f5c0&scoped=true"
import script from "./CalendarAside.vue?vue&type=script&lang=js"
export * from "./CalendarAside.vue?vue&type=script&lang=js"
import style0 from "./CalendarAside.vue?vue&type=style&index=0&id=5356f5c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5356f5c0",
  null
  
)

export default component.exports